import ErrorBoundaryFallBack from '@/components/custom/fallback-view/error-boundary-fallback';
import LoadingFallback from '@/components/custom/fallback-view/loading-fallback';
import loadable from '@loadable/component';
import { Navigate, createBrowserRouter } from 'react-router';
import { routerPaths } from './router-paths';
import { useAxiosInterceptor } from '@/hooks/utils/use-axios-interceptor';
import { Outlet } from 'react-router';

const AppWrapper = () => {
  useAxiosInterceptor();
  return <Outlet />;
};

const Layout = loadable(() => import('@/components/custom/layout/layout'), {
  fallback: <LoadingFallback />,
});

const Login = loadable(() => import('@/pages/login-page'), {
  fallback: <LoadingFallback />,
});

const CallCenter = loadable(() => import('@/pages/call-center'), {
  fallback: <LoadingFallback />,
});

const routes = [
  {
    element: <AppWrapper />,
    errorElement: <ErrorBoundaryFallBack />,
    children: [
      {
        path: routerPaths.root,
        element: (
          <Navigate
            to={routerPaths.login}
            replace
          />
        ),
      },
      {
        element: <Layout />,
        children: [
          {
            path: `${routerPaths.callCenter}`,
            element: <CallCenter />,
          },
        ],
      },
      {
        path: routerPaths.login,
        element: <Login />,
      },
    ],
  },
];

const projectRouters = createBrowserRouter(routes);

export default projectRouters;
